import { SecurityQuestionRequest } from "./security-question-request.model";

export class ConfirmEmailRequestModel {
    UserId: string;
    Token: string;
    IsConfirmedEmail: boolean;
    SecurityQuestion:SecurityQuestionRequest;
}